import { render, staticRenderFns } from "./FamilyGroupReqs.vue?vue&type=template&id=7be8f4e1&"
import script from "./FamilyGroupReqs.vue?vue&type=script&lang=js&"
export * from "./FamilyGroupReqs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports